import { ChevronRight } from "lucide-react";

// Einstiegs-Auswahl im Menükarten-Look: große Karten statt vieler Menüpunkte
export const AuswahlHub = ({ titel, hinweis, karten, testid, extra }) => (
  <div className="space-y-8 animate-in fade-in slide-in-from-bottom-2 duration-300" data-testid={testid}>
    {(titel || hinweis) && (
      <div>
        {titel && <p className="text-[10px] uppercase tracking-[0.25em] text-[#BA6D52]">{titel}</p>}
        {hinweis && <p className="text-sm text-[#757067] mt-2 max-w-2xl">{hinweis}</p>}
      </div>
    )}
    <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
      {karten.map((k) => {
        const Icon = k.icon;
        return (
          <button key={k.id} onClick={k.onClick} data-testid={`hub-${k.id}`}
            className="group relative text-left border border-[#E3DECE] bg-[#FAF5F1] hover:border-[#BA6D52] hover:-translate-y-0.5 hover:shadow-[0_18px_40px_-28px_rgba(120,80,48,0.5)] transition-all duration-200 p-6 min-h-[168px] flex flex-col">
            <span className="absolute top-3 left-3 w-3 h-3 border-t border-l border-[#BA6D52]/0 group-hover:border-[#BA6D52]/70 transition-colors" />
            <span className="absolute bottom-3 right-3 w-3 h-3 border-b border-r border-[#BA6D52]/0 group-hover:border-[#BA6D52]/70 transition-colors" />
            <div className="flex items-start justify-between gap-3">
              <Icon size={22} className="text-[#BA6D52]" />
              {k.badge ? (
                <span className="text-[10px] uppercase tracking-[0.15em] text-[#BA6D52] border border-[#BA6D52] px-2 py-0.5">
                  {k.badge}
                </span>
              ) : null}
            </div>
            <p className="font-serif text-xl text-[#2C2A26] mt-4">{k.label}</p>
            <p className="text-xs text-[#757067] mt-2 leading-relaxed flex-1">{k.hint}</p>
            <span className="mt-4 inline-flex items-center gap-1.5 text-[10px] uppercase tracking-[0.2em] text-[#BA6D52] opacity-0 group-hover:opacity-100 transition-opacity">
              Öffnen <ChevronRight size={12} />
            </span>
          </button>
        );
      })}
    </div>
    {extra}
  </div>
);

export default AuswahlHub;
